import React, { useState } from 'react'
import { Icon, FormControl, FormLabel, Box, Text, Grid, Input, Button } from '@chakra-ui/core';
import { apiUrl } from '../config/keys';
import Axios from 'axios';
import { tokenAtom, userAtom } from '../global/gloablState';
import { useRecoilValue, useRecoilState } from 'recoil';

const MenuEdit = () => {
    //Global State
    const token = useRecoilValue(tokenAtom)
    const [user, setUser] = useRecoilState(userAtom)

    //Edit A Menu Item
    const [itemName, setItemName] = useState("")
    const [itemPrice, setItemPrice] = useState(0)
    const [currentlyEditing, setCurrentlyEditing] = useState("")

    //Add New Item
    const [newItemName, setNewItemName] = useState("")
    const [newItemPrice, setNewItemPrice] = useState(0)


    const updateMenu = (myMenu) => {
        console.log(myMenu)
        Axios.post(`${apiUrl}/restro/menu`, myMenu, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            setUser(res.data)
            localStorage.setItem('user', JSON.stringify(res.data));
        })
    }

    const updateItem = (itemId) => {
        setCurrentlyEditing(null)
        let menu = user.menu.map(menuItem => {
            if (menuItem._id === itemId) {
                return ({
                    _id: menuItem._id,
                    item: itemName,
                    price: itemPrice
                })
            } else {
                return menuItem
            }
        });
        updateMenu({ ...user, menu });
    }

    const deleteItem = (itemId) => {
        let menu = user.menu.filter(menuItem => menuItem._id !== itemId);
        updateMenu({ ...user, menu })
    }

    const addItem = () => {
        updateMenu({
            ...user, menu: [...user.menu, {
                item: newItemName,
                price: newItemPrice
            }]
        })
        setNewItemName("")
        setNewItemPrice("")
    }

    return (
        <div>
            <Box px={["5%", "10%"]} py="5">
                <Text fontWeight="bold" fontSize="2xl" pb={5}>Edit Menu</Text>
                <Grid templateColumns="repeat(4, 1fr)" py={4} gap={6}>
                    <Text fontWeight="bold">Name</Text>
                    <Text fontWeight="bold">Price</Text>
                    <Text fontWeight="bold">Edit</Text>
                    <Text fontWeight="bold">Delete</Text>
                </Grid>
                {
                    user.menu.map(({ _id, item, price }) => (
                        <React.Fragment key={_id}>
                            <Box display={(currentlyEditing === _id) && "none"}>
                                <Grid templateColumns="repeat(4, 1fr)" py={2} gap={6}>
                                    <Text>{item}</Text>
                                    <Text>{price}</Text>
                                    <Icon name="edit" onClick={() => {
                                        setCurrentlyEditing(_id);
                                        setItemName(item)
                                        setItemPrice(price)
                                    }} />
                                    <Icon name="delete" onClick={() => deleteItem(_id)} />
                                </Grid>
                            </Box>
                            <Box display={!(currentlyEditing === _id) && "none"}>
                                <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                                    <Input w="50%" value={itemName} onChange={(e) => setItemName(e.target.value)} />
                                    <Input w="50%" type="number" value={itemPrice} onChange={(e) => setItemPrice(e.target.value)} />
                                    <Button w="50%" variantColor="green" onClick={() => updateItem(_id)}>Save</Button>
                                    <Button w="50%" variantColor="red" onClick={() => setCurrentlyEditing(null)}>Cancel</Button>
                                </Grid>
                            </Box>
                        </React.Fragment>
                    ))
                }
                <Text fontWeight="bold" fontSize="xl" py={10}>Add A Item</Text>
                <FormControl>
                    <FormLabel htmlFor="name">Item Name</FormLabel>
                    <Input type="text" id="name" value={newItemName} onChange={(e) => setNewItemName(e.target.value)} />
                    <FormLabel mt={4} htmlFor="price">Item Price</FormLabel>
                    <Input type="number" id="price" value={newItemPrice} onChange={(e) => setNewItemPrice(e.target.value)} />
                    <Button
                        mt={4}
                        variantColor="green"
                        onClick={() => addItem()}
                    >Add Item</Button>
                </FormControl>
            </Box>
        </div>
    )
}

export default MenuEdit
